import { render, staticRenderFns } from "./OmitLineMy.vue?vue&type=template&id=52a22d80&scoped=true"
import script from "./OmitLineMy.vue?vue&type=script&lang=js"
export * from "./OmitLineMy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a22d80",
  null
  
)

export default component.exports